export enum PostRedirectAction {
  CourseEventRegister = 'courseEventRegister',
  JoinElearning = 'joinElearning',
  JoinCourseBundle = 'joinCourseBundle',
}
